import { defineMessages } from 'react-intl';

export default defineMessages({
  currencySelectorSearchPlaceholder: {
    id: 'neptune.ExpressiveMoneyInput.currency.search.placeholder',
    defaultMessage: 'Type a currency / country',
  },

  currencySelectorSelectCurrency: {
    id: 'neptune.ExpressiveMoneyInput.currency.select.currency',
    defaultMessage: 'Select currency',
  },
});
